import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";

import ClienteSVG from "../../assets/icons/card.svg";
import MarketSVG from "../../assets/icons/market.svg";
import MoneySVG from "../../assets/icons/money.svg"

function OverviewDesktop({ app, config }) {
  const [moreInfoVisible, setMoreInfoVisible] = useState(false);

  const LayoutCardsWrapper = styled("div")({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: moreInfoVisible ? '180%' : '120%',
    justifyContent: "flex-start",
    width: "100%",
  });

  const LayoutCardWrapper = styled.div`
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 10px;
    gap: 10px;
  `;



  const toggleMoreInfo = () => {
    setMoreInfoVisible(!moreInfoVisible);
  };

  return (
    <div className="app overview">

      <div className="appContent">

        <LayoutCardsWrapper>

          <LayoutCardWrapper>

            <Card
              header={{
                hardTitle: "DN Total",
              }}
              className={"group-top"}
              style={{
                height: moreInfoVisible ? '190%' : '80%',
                gap: "5px"
              }}
            >

              <div className="row-kpis tutorial-second-step">

                <Card
                  header={{
                    hardTitle: "PDVs Cliente",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                >
                  <div className="container-items">
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="xLbyFQ"
                      reference={{
                        id: "xLbyFQ",
                      }}
                    />

                    <div className="container-img">
                      <img src={ClienteSVG} alt="icon" width={40} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "PDVs Mercado",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                >
                  <div className="container-items">
                    <div style={{
                      paddingLeft: "15px"
                    }}>
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="KnJJjQn"
                        reference={{ id: "KnJJjQn" }}
                      />
                    </div>

                    <div className="container-img">
                      <img src={MarketSVG} alt="icon" width={40} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "%Cl. vs Mer.",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                  classStyle={"row-header"}
                >
                  <div className="container-items">
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="mvxFr"
                      reference={{ id: "mvxFr" }}
                    />

                    <div className="container-img">
                      <img src={ClienteSVG} alt="icon" width={40} />
                      <img src={MarketSVG} alt="icon" width={40} style={{
                        marginLeft: "-7px"
                      }} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "Cdd. Cliente",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                  classStyle={"row-header"}
                >
                  <div className="container-items">
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="ApwRGS"
                      reference={{ id: "ApwRGS" }}
                    />

                    <div className="container-img">
                      <img src={ClienteSVG} alt="icon" width={40} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "Cdd. Mercado",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                  classStyle={"row-header"}
                >
                  <div className="container-items">
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="wxpULzN"
                      reference={{ id: "wxpULzN" }}
                    />

                    <div className="container-img">
                      <img src={MarketSVG} alt="icon" width={40} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "%Cdd. vs Mer.",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                  classStyle={"row-header"}
                >
                  <div className="container-items">
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="mKjzSm"
                      reference={{ id: "mKjzSm" }}
                    />

                    <div className="container-img">
                      <img src={ClienteSVG} alt="icon" width={40} />
                      <img src={MarketSVG} alt="icon" width={40} style={{
                        marginLeft: "-7px"
                      }} />
                    </div>
                  </div>
                </Card>

                <Card
                  header={{
                    hardTitle: "TMmês/cliente",
                  }}
                  style={{
                    width: "100%",
                    position: "relative"
                  }}
                  classStyle={"row-header"}
                >
                  <div className="container-items">
                    <span style={{ marginTop: "5px" }}>R$</span>
                    <NativeObject
                      className="kpiValueBold"
                      app={app}
                      key="yNebnX"
                      reference={{ id: "yNebnX" }}
                    />

                    <div className="container-img">
                      <img src={MoneySVG} alt="icon" width={40} />
                    </div>
                  </div>
                </Card>

              </div>

              <div className="row-more-info">
                <Card
                  style={{
                    display: moreInfoVisible ? 'block' : 'none'
                  }}
                  className={"additional-cards"}
                >
                  <span>DN TOTAL</span>
                  <span className="desc-add">Ticket médio mês cliente</span>
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between"
                  }}>
                    <span>R$</span>
                    <NativeObject
                      app={app}
                      key="ZDdcP"
                      reference={{ id: "ZDdcP" }}
                    />
                  </div>

                </Card>

                <Card
                  style={{
                    display: moreInfoVisible ? 'block' : 'none'
                  }}
                  className={"additional-cards"}
                >
                  <span style={{ color: "black" }}>DN QUALIFICADA</span>
                  <span className="desc-add">Ticket médio mês cliente / % vs. DN TOTAL</span>
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between"
                  }}>
                    <span>R$</span>
                    <NativeObject
                      app={app}
                      key="JTJjJD"
                      reference={{ id: "JTJjJD" }}
                    />
                    <span>/</span>
                    <NativeObject
                      app={app}
                      key="htDT"
                      reference={{ id: "htDT" }}
                    />
                  </div>

                </Card>

                <Card
                  style={{
                    display: moreInfoVisible ? 'block' : 'none'
                  }}
                  className={"additional-cards"}
                >
                  <span style={{ color: "black" }}>DN TOP</span>
                  <span className="desc-add">Ticket médio mês cliente / % vs. DN TOTAL</span>
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-around",
                  }}>
                    <span>R$</span>
                    <NativeObject
                      app={app}
                      key="TpUFY"
                      reference={{ id: "TpUFY" }}
                    />
                    <span>/</span>
                    <NativeObject
                      app={app}
                      key="PhrcYq"
                      reference={{ id: "PhrcYq" }}
                    />
                  </div>

                </Card>
              </div>

              <div className="kpi-qlik" style={{ display: moreInfoVisible ? 'block' : 'none' }}>
                <NativeObject
                  app={app}
                  key="RPfen"
                  reference={{ id: "RPfen" }}
                  style={{ width: "100%", height: "100%" }}
                />
              </div>

              <Button variant="contained" className="button-more" onClick={toggleMoreInfo}>
                <span>{moreInfoVisible ? "Visualizar menos" : "Visualizar todos"}</span>
              </Button>

            </Card>

            <div className={"container-table"}>

              <div className="align-tables">

                <div className="side-tables-one">
                  <Card
                    className="tutorial-third-step"
                    app={app}
                    header={{
                      hardTitle: "PDVs",
                    }}
                    style={{ width: "100%", height: "100%" }}
                    exportContainer
                    exportTable
                    exportTableId="fng"
                  >
                    <NativeObject
                      app={app}
                      key="fng"
                      reference={{ id: "fng" }}
                    />
                  </Card>

                  <Card
                    className="tutorial-fourth-step"
                    app={app}
                    header={{
                      hardTitle: "Cidades",
                    }}
                    style={{ width: "100%", height: "100%" }}
                    exportContainer
                    exportTable
                    exportTableId="keeFpfv"
                  >
                    <NativeObject
                      app={app}
                      key="keeFpfv"
                      reference={{ id: "keeFpfv" }}
                    />
                  </Card>

                </div>

                <div className="side-tables-two">

                  <Card
                    className="tutorial-fifth-step"
                    app={app}
                    style={{ width: "100%", height: "100%" }}
                  >
                    <NativeObject
                      app={app}
                      key="Uxvt"
                      reference={{ id: "Uxvt" }}
                      style={{ paddingTop: "30px" }}
                    />
                  </Card>

                </div>

              </div>

            </div>

          </LayoutCardWrapper>

        </LayoutCardsWrapper >

      </div >

    </div >
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
